import styled from 'styled-components';
import {Column, Row} from '../../common/Layouts/Layouts';
import {ISrpHotelCardPersuasionTypes} from '../../../../../shared/pages/SRP/redux/types';

function getHiddenDropDownWrapperDivPositioning(direction) {
  switch (direction) {
    case 'top':
      return 'bottom: 1.5rem; left: 0;';
    case 'bottom-right':
      return 'top: 1.5rem; left: 0;';

    default:
      // 'bottom'
      return 'top: 2rem; right: 0;';
  }
}

function getTipUIPositioning(direction) {
  switch (direction) {
    case 'top':
      return 'bottom: -0.2rem; left: 15%;';
    case 'bottom-right':
      return 'top: -0.2rem; left: 10%;';

    default:
      // 'bottom'
      return 'top: -0.2rem; right: 15%;';
  }
}

function getTipUIPointerDirection(direction) {
  switch (direction) {
    case 'top':
      return 'transform: translate(-50%, -50%) rotate(45deg);';

    default:
      // 'bottom'
      return 'transform: translate(-50%, 50%) rotate(45deg);';
  }
}

// HOVER STUFF

export const PersuasionHoverTitleSpan = styled.span`
  font-size: ${props => (props.type === 'belowPricePersuasion' ? '1rem' : '')};
`;

export const HiddenDropdownWrapperDiv = styled.div`
  width: ${props => props.width || '22rem'};
  ${props => getHiddenDropDownWrapperDivPositioning(props.direction)}
  top: ${props => props.top};
  bottom: ${props => props.bottom};
  right: ${props => props.right};
  left: ${props => props.left};
  max-width: ${props => props.width || '30rem'};
  padding: ${props => props.theme.spacing.base} 0;
  z-index: ${props => props.theme.misc.zIndex.xsmall};
  visibility: hidden;
  transition: opacity 0.8s;
  position: absolute;
`;

export const HoverTargetWrapperDiv = styled.span`
  position: relative;
  text-align: left;
  display: inline-flex;
  /* align-self: flex-start; */
  margin-right: ${props =>
    [
      'contentPersuasion2',
      'belowBannerPersuasion',
      'abovePricePersausion',
      'belowPricePersuasion',
    ].indexOf(props.type) > -1
      ? ''
      : props.theme.spacing.small.s8};
  margin-top: ${props =>
    props.hasMultiple && !props.isContentPersuasion2 ? props.theme.spacing.small : ''};
  &:hover > ${HiddenDropdownWrapperDiv} {
    visibility: visible;
  }
`;

export const TopDiv = styled.div(
  props => `
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 0 5px 0 rgba(150, 150, 150, 0.5);
`,
);

const TipUI = styled.div`
  position: absolute;
  margin-left: -${props => props.theme.spacing.base};
  width: 2.4rem;
  height: 1.2rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
  }
`;

export const TipPositioning = styled(TipUI)`
  ${props => getTipUIPositioning(props.direction)}
  top: ${props => props.top};
  bottom: ${props => props.bottom};
  left: ${props => props.left};
  right: ${props => props.right};
  &::after {
    ${props => getTipUIPointerDirection(props.direction)}
    transform: ${props => props.transform};
    background: white/* ${props => props.bgColor} */;
    box-shadow: 0 ${props => props.theme.spacing.small.s1} ${props => props.theme.spacing.small.s4}
      ${props => props.theme.colors.shadow.base};
  }
`;

// CONTENT STUFF

export const ListDropDownWrapper = styled.div(
  props => `
width: 100%;
display: flex;
list-style-type: none;
overflow: hidden;
padding: ${props.theme.spacing.small.s5} 0 0;
flex-direction: column;
> li {
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
  padding: ${props.theme.spacing.base};
  position: relative;
  &:last-child {
    border-bottom: none;
  }
}
`,
);

export const TextBlockDropDownWrapper = styled(Column)`
  padding:0px 20px 15px;
  color: ${props => props.color};
  background-color: white; /* ${props => props.bgColor} */;
  border-radius: 0.4rem;
  height: ${props => props.height || ''};
`;

export const RoundBoxWrap = styled.div(
  props => `
  width: 1.5rem;
  height: 1.5rem;

`,
);

export const TextBlockDDHeading = styled(Row)`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  padding: ${props => props.theme.spacing.small.s3} ${props => props.theme.spacing.nospacing}
    ${props => props.theme.spacing.small.s3} ${props => props.theme.spacing.nospacing};
  margin-bottom: ${props => props.theme.spacing.small.s5};
  margin-top: ${props => props.theme.spacing.base};
  background: ${props => props.bgColor};
  color: ${props => props.color};
  border-radius: 2.5rem;
`;

export const TextBlockDDHeadingSpan = styled.span`
  color: ${props => props.color};
  background-color: ${props => props.bgColor};
  /* color: ${props => props.color || props.theme.colors.green.base}; */
  /* padding: 0 0 0 ${props => props.theme.spacing.small.s5}; */
  text-transform: capitalize;
`;

export const TextBlockDDFilterText = styled.p`
  line-height: 1.3;
  font-size: ${props => props.theme.font.large.font14};
  padding-top: ${props => props.theme.spacing.base};
`;

export const BlueLinkText = styled.span`
  margin-top: ${props => props.theme.spacing.base};
  color: ${props => props.theme.colors.goBrand.blue};
  cursor: pointer;
`;

// CONTENT STUFF

export const WrapperDiv = styled.span`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;

function getPaddingMainTextTag(type: ISrpHotelCardPersuasionTypes, hasBgColor) {
  switch (type) {
    case 'customLocation':
    case 'contentPersuasion1':
    case 'contentPersuasion2':
    case 'aboveRatePlanPersuasion':
      return `0.3rem ${hasBgColor ? '0.8rem' : '0'} 0.3rem ${hasBgColor ? '0.8rem' : '0'}`;
    case 'belowPricePersuasion':
      return `0.3rem 0 0.3rem 0`;
    case 'belowBannerPersuasion':
      return `0`;

    default:
      return '0.3rem 0.8rem 0.3rem 0.8rem';
  }
}

export const TextWrapperSpan = styled.div`
  ${props => (props.hasHover ? 'cursor: pointer;' : '')}
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  border-radius: ${props => props.type !== 'contentPersuasion2' ? props.theme.misc.borderRadius.custom(15) : props.theme.misc.borderRadius.custom(2)};
  font-size: ${props => (props.type == 'contentPersuasion2' ? props.theme.font.base : '')};
  ${props => (props.hasHover ? 'cursor: pointer;' : '')}
  color: ${props => props.color};
  ${props => (props.isGradient ? `background-image: ${props.bgColor};` : '')}
  text-transform: capitalize;
  padding: ${props => getPaddingMainTextTag(props.type, false /* props.hasBgColor */)};
  border: ${props => props.showLabelTextBorder ? `1px solid ${props.color}` : props.border ? props.border : 'none'};
  display: flex;
  align-items: center;
  span {
    max-width: ${props =>
      props.type === 'aboveRatePlanPersuasion' && !props.hasSingleItem ? '16rem' : '30rem'};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const IconWrapperDiv = styled.div`
  display: flex;
  padding: ${props => props.theme.spacing.small.s5};
  flex-direction: row;
  align-items: center;
`;

export const TextWrapper = styled.p(
  props => `
  padding-left: ${props.theme.spacing.small.s8};
  color: ${props.theme.colors.grey.grey75};
  line-height: 1.3;
`,
);

export const MiniIconWrapperSpan = styled.span`
  margin-top: ${props => props.theme.spacing.small.s5};
  margin-right: ${props => props.theme.spacing.small.s5};
`;

export const MainTextIconWrapperSpan = styled.span`
  display: flex;
  align-items: center;
  margin-right: ${props => (props.type === 'belowPricePersuasion' ? '0.5rem' : '0.8rem')};
`;

export const TextLabelIconContainer = styled.span(
  props => `
  // margin: -3px 0 0 0;
  padding: 0 ${props.theme.spacing.small.s5} 0 0;
`,
);

export const FreeCancelTipTopBlock = styled.div`
  width:100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const CancelImg = styled.div`
  width:3rem;
  height: 4.3rem;
  margin-right: 1rem;
`;

export const CancelInfoTextWrap = styled.div`
  width:90%;
  display: flex;
  flex-direction: column;
  padding-top:0.5rem;
`;

export const InfoFadedText = styled.p`
  font-size:1.2rem;
  color: #9b9b9b;
  letter-spacing: -0.08px;
`;

export const InfoMainBoldText = styled.p`
  font-size: 1.5rem;
  color: #000;
  letter-spacing: -0.1px;
  font-weight: 900;
`;

export const CancelSliderWrap = styled.div`
  width:100%;
  display: flex;
  margin-top:1.5rem;
  height: 24px;
  border-radius: 2.15rem;
  box-shadow: 1px 1px 2px -1px rgba(163, 155, 155, 0.22);
  border: solid 1px #b9d1cf;
  background-color: #ffffff;
  position: relative;
  align-items: center;
`;

export const SliderInnerWrap = styled.div(
  props => `
    width: ${props.width};
    height: 24px;
    background-image: linear-gradient(260deg, #2eb4af ,  #249995 );
    position: relative;
    border-radius: ${props.full ? '2.15rem' : '2.15rem 0 0  2.15rem'};
    display: flex;
    align-items: center;
    justify-content: center;
  `
);

export const SliderFirstCircle = styled.div`
  width: 16px;
  height: 16px;
  box-shadow: 1px 1px 2px -1px rgba(255, 255, 255, 0.22), inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  border-radius:50%;
  position: absolute;
  top:3px;
  left:3px;
`;

export const SliderOtherCircle = styled.div`
  width: 16px;
  height: 16px;
  box-shadow: 1px 1px 2px -1px rgba(255, 255, 255, 0.22), inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  position: absolute;
  top: 3px;
  right:3px;
  border-radius:50%;
`;

export const FreeCancelMainText = styled.p`
  font-size:11px;
  color: #fff;
  span{
    font-weight: 900;
  }
`;

export const NowText = styled.p`
  position: absolute;
  top:3.5rem;
  left:0;
  font-size:1.1rem;
  color: #000;
  font-weight: 900;
`;

export const FreeDateText = styled.p`
  position: absolute;
  top:2.4rem;
  right: 0;
  border-right: 1px solid #2eb4af;
  height: 2.6rem;
  display: flex;
  align-items: flex-end;
  padding-right:1rem;
  font-size:1.1rem;
  color: #000;
  font-weight: 900;
`;

export const finalCheckDate = styled.p`
  position: absolute;
  top:3.5rem;
  right:0;
  font-size:1.1rem;
  color: #000;
  font-weight: 900;

  span{
    font-weight: 200;
  }
`;